import styled from 'styled-components'

export const SEmptyData = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  height: 100px;
  min-height: 200px;
`
